<span *ngIf="patientAttachment.duplicatePatientAttachment">
  [<span class="duplicate">DUPLICATE</span>]
</span>
